import { Forbidden, InternalServer, NotFound, SigninOidcCallback, SignoutOidc, SignoutOidcCallback } from '../pages';
export const authRoutes = [
    // Authentication Routes
    {
        path: '/signin-oidc',
        Component: SigninOidcCallback
    },
    {
        path: '/signout-callback-oidc',
        Component: SignoutOidcCallback
    },
    {
        path: '/signout-oidc',
        Component: SignoutOidc
    }
];
export const errorRoutes = [
    // Error Pages
    {
        path: '/forbidden',
        Component: Forbidden
    },
    {
        path: '/internal-server-error',
        Component: InternalServer
    },
    {
        path: '*',
        Component: NotFound
    }
];
